import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import('@/styles/components/chart.less')
export const legendAndChart = {
  async mounted() {
    await this.createGraph()
  },
  methods: {
    async createGraph() {
      this.chart = am4core.create(this.chartId, am4charts.XYChart)

      this.chart.colors.list = this.colorList.map(color => am4core.color(color))

      this.setupCategoryAxis()
      this.setupValueAxis()
      this.createLineSeries()

      this.createLabelPeriod()

      const chart = this.chart
      this.createLabelNotData()

      this.chart.events.on(
        'beforedatavalidated',
        function() {
          if (chart.data.length === 0) {
            this.noDataLabel.show()
          } else {
            if (this.noDataLabel) {
              this.noDataLabel.hide()
            }
          }
        },
        this
      )

      this.chart.data = this.getData()
      this.chart.cursor = new am4charts.XYCursor()
      this.chart.logo.disabled = true
      this.setupLegend()
    },
    setupCategoryAxis() {
      let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis())
      categoryAxis.dataFields.category = 'date'
      categoryAxis.cursorTooltipEnabled = false
      categoryAxis.renderer.labels.template.fontSize = 13
    },
    setupValueAxis() {
      const interfaceColors = new am4core.InterfaceColorSet()
      this.valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis())
      this.valueAxis.renderer.labels.template.fontSize = 13
      this.valueAxis.cursorTooltipEnabled = false
      if (this.chart.yAxes.indexOf(this.valueAxis) != 0) {
        this.valueAxis.syncWithAxis = this.chart.yAxes.getIndex(0)
      }
      this.valueAxis.renderer.line.strokeOpacity = 1
      this.valueAxis.renderer.line.stroke = interfaceColors.getFor('stroke')
    },
    createLineSeries() {
      this.series = this.chart.series.push(new am4charts.LineSeries())
      this.series.dataFields.categoryX = 'date'
      this.series.dataFields.valueY = 'value'
      this.series.strokeWidth = 2
      this.series.yAxis = this.valueAxis
      this.series.stroke = this.chart.colors.getIndex(0).hex
      this.series.fill = this.chart.colors.getIndex(0).hex
      this.series.fillOpacity = 0.1
      this.series.tooltip.getFillFromObject = false
      this.series.tooltip.background.fill = am4core.color('#fff')
      this.series.tooltip.label.fill = am4core.color('#000')
      this.series.tooltip.background.fillOpacity = 1
      this.series.tooltip.label.interactionsEnabled = true
      this.series.tooltip.fontSize = 13
      this.series.tooltip.pointerOrientation = 'down'
      if (this.showDateInTooltip) {
        this.series.tooltipText = `[bold]{valueY}{unit}[/] \n {shadedText}\n {date}`
      } else {
        this.series.tooltipText = `[bold]{valueY}{unit}[/] \n {shadedText}`
      }
      //this.series.tooltipText = this.showDateInTooltip ? this.series.tooltipText + `\n {date}` : this.series.tooltipText
      this.series.tooltip.label.textAlign = 'middle'

      this.bullet = this.series.bullets.push(new am4charts.CircleBullet())
      this.bullet.circle.strokeWidth = 2
      const self = this

      this.bullet.adapter.add('fill', function(fill, target) {
        if (target.dataItem.dataContext.shaded) {
          return am4core.color('#FFFFFF')
        } else {
          return self.chart.colors.getIndex(self.selectedLegend)
        }
      })

      this.bullet.adapter.add('stroke', function(fill, target) {
        if (target.dataItem.dataContext.shaded) {
          return self.chart.colors.getIndex(self.selectedLegend)
        } else {
          return am4core.color('#FFFFFF')
        }
      })

      this.typeCreatedSeries = 'LineSeries'
    },
    createColumnSeries() {
      this.series = this.chart.series.push(new am4charts.ColumnSeries())
      this.series.dataFields.categoryX = 'date'
      this.series.dataFields.openValueY = 'closeValue'
      this.series.dataFields.valueY = 'value'
      this.series.fillOpacity = 0
      this.series.strokeOpacity = 1
      this.series.columns.template.width = 0.1
      this.series.columns.template.strokeWidth = 3

      this.series.columns.template.adapter.add('strokeDasharray', function(dasharray, target) {
        if (target.dataItem.dataContext.shaded) {
          return '3,3'
        } else {
          return 'none'
        }
      })

      this.series.tooltip.getFillFromObject = false
      this.series.tooltip.background.fill = am4core.color('#fff')
      this.series.tooltip.label.fill = am4core.color('#000')
      this.series.tooltip.background.fillOpacity = 1
      this.series.tooltip.fontSize = 13
      this.series.tooltip.label.textAlign = 'middle'
      this.series.tooltip.pointerOrientation = 'down'
      this.series.tooltipText = `[bold]{valueY}/{openValueY}[/] \n {shadedText}\n {date}`

      const lineSeriesUp = this.chart.series.push(new am4charts.LineSeries())
      lineSeriesUp.dataFields.categoryX = 'date'
      lineSeriesUp.dataFields.openValueY = 'closeValue'
      lineSeriesUp.dataFields.valueY = 'value'
      lineSeriesUp.strokeWidth = 2
      lineSeriesUp.stroke = am4core.color('#4C43E5')
      lineSeriesUp.fill = am4core.color('#4C43E5')
      lineSeriesUp.fillOpacity = 0.1

      const lineSeriesDown = this.chart.series.push(new am4charts.LineSeries())
      lineSeriesDown.dataFields.categoryX = 'date'
      lineSeriesDown.dataFields.valueY = 'closeValue'
      lineSeriesDown.strokeWidth = 2
      lineSeriesDown.stroke = am4core.color('#4C43E5')
      lineSeriesDown.fill = am4core.color('#4C43E5')
    },
    createLabelPeriod() {
      this.label = this.chart.createChild(am4core.Label)
      this.label.text = this.datePeriodStr
      this.label.fontSize = 14
      this.label.align = 'center'
      this.label.isMeasured = false
      this.label.x = 70
      this.label.y = 10
    },
    createLabelNotData() {
      this.noDataLabel = this.chart.plotContainer.createChild(am4core.Label)
      this.noDataLabel.text = this.$t('courseReport.emptyReport')
      this.noDataLabel.fontSize = 18
      this.noDataLabel.align = 'center'
      this.noDataLabel.valign = 'middle'
      this.noDataLabel.isMeasured = false
      this.noDataLabel.x = am4core.percent(50)
      this.noDataLabel.y = am4core.percent(50)
      this.noDataLabel.horizontalCenter = 'middle'
      this.noDataLabel.verticalCenter = 'middle'
      this.noDataLabel.paddingTop = 10
      this.noDataLabel.paddingRight = 20
      this.noDataLabel.paddingBottom = 10
      this.noDataLabel.paddingLeft = 20
      this.noDataLabel.background.fill = am4core.color('#fff')
      this.noDataLabel.background.fillOpacity = 0.8
    },
    setupLegend() {
      let self = this
      this.chart.events.on(
        'ready',
        () => {
          const customLegend = document.getElementById(this.legendId)
          self.createLegendItems(customLegend)
          self.setupLegendClickHandlers(customLegend)
        },
        this
      )
    },
    createLegendItems(customLegend) {
      /* eslint-disable-next-line no-unused-vars */
      for (let key in this.listOfLegend) {
        const color = this.chart.colors.getIndex(key).hex
        const seriesName = this.listOfLegend[key]
        const isActive = Number(key) === this.selectedLegend ? true : false
        const classActive = isActive ? `legend-item active-item` : `legend-item`
        customLegend.innerHTML +=
          '<div class="' +
          classActive +
          `" id="legend-item-` +
          key +
          '">' +
          `<div class="legend-marker" style="background: ` +
          color +
          '"></div>' +
          seriesName +
          '</div>'
      }
    },
    setupLegendClickHandlers(customLegend) {
      const legendItems = customLegend.querySelectorAll(`.legend-item`)
      const self = this
      legendItems.forEach(function(item, index) {
        item.addEventListener('click', () => {
          self.handleLegendItemClick(index, legendItems)
        })
      })
    }
  }
}
